module.exports = __webpack_public_path__ + "img/1.9d7477ce.png";